import { ActionIcon, rem, Stack, Text } from "@mantine/core"
import { IconBrandGithub, IconBrandGitlab, IconBrandLinkedin, IconBrandPaypal } from "@tabler/icons-react"

import classes from "./Renders.module.css"

export function renderFooter(): React.ReactElement {
  return (
    <footer>
      <Stack gap={rem(8)} justify="center" align="center" className={classes.footer}>
        <Text size={rem(14)}>© 2018-2025 Aurora OSS</Text>
        <Text size={rem(12)}>{"All rights reserved."}</Text>
        <Text size={rem(12)} c={"dimmed"} style={{ whiteSpace: "pre-line", textAlign: "center" }}>
          {"All trademarks are property of their respective owners."}
        </Text>

        <ActionIcon.Group>
          <ActionIcon
            variant="default"
            size="lg"
            aria-label="gitlab-link"
            onClick={() => window.open("https://gitlab.com/AuroraOSS")}
          >
            <IconBrandGitlab size={20} stroke={1.5} />
          </ActionIcon>

          <ActionIcon
            variant="default"
            size="lg"
            aria-label="github-link"
            onClick={() => window.open("https://github.com/whyorean")}
          >
            <IconBrandGithub size={20} stroke={1.5} />
          </ActionIcon>

          <ActionIcon
            variant="default"
            size="lg"
            aria-label="linkedin-link"
            onClick={() => window.open("https://www.linkedin.com/in/whyorean/")}
          >
            <IconBrandLinkedin size={20} stroke={1.5} />
          </ActionIcon>

          <ActionIcon
            variant="default"
            size="lg"
            aria-label="Likes"
            onClick={() => window.open("https://www.paypal.com/paypalme/auroradev")}
          >
            <IconBrandPaypal size={20} stroke={1.5} />
          </ActionIcon>
        </ActionIcon.Group>
      </Stack>
    </footer>
  )
}
